import { memo, useRef } from "react";
import { ESIIncludeWithClientFetch } from "../__shared__/ESIIncludeWithClientFetch/ESIIncludeWithClientFetch";

export type Props = {
  productId: string;
  placement: string;
  testId: string;
  skuId: string;
  pageHierarchy: string;
  isCtaPremiumDesign?: boolean;
  isPremiumColourSelector?: boolean;
};

export const RecommendationBundlesUI = memo(function RecommendationBundlesUI({
  productId,
  placement,
  testId,
  skuId,
  pageHierarchy,
  isCtaPremiumDesign = false,
  isPremiumColourSelector = false,
}: Props) {
  const searchParams = useRef(
    new URLSearchParams(
      Object.entries({
        placement,
        productId,
        skuId,
        pageHierarchy,
        ...(isCtaPremiumDesign ? { ffJLDSv31Patch: "off" } : {}),
        ...(isPremiumColourSelector ? { ffSquareSwatches: "on" } : {}),
      }),
    ).toString(),
  );
  return (
    <div
      id={`${testId}-${placement}-wrapper`}
      data-testid={`${testId}-${placement}-wrapper`}
    >
      <ESIIncludeWithClientFetch
        id={`recommendation-bundles-esi-${placement.toLowerCase()}`}
        src={`/esi/recommendations/bundles/?${searchParams.current}`}
      />
    </div>
  );
});
